import * as Yup from 'yup';

export default Yup.object().shape({
  name: Yup.string().required('Campo obrigatório'),
  value: Yup.string()
    .nullable('Campo obrigatório')
    .required('Campo obrigatório'),
});
